import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { QueryClient, QueryClientProvider as TanstackProvider } from '@tanstack/react-query';

export default function QueryClientProvider({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 15000,
            retry: false,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );
  return <TanstackProvider client={queryClient}>{children}</TanstackProvider>;
}
